<template>
    <div class="loading-wrapper-terms" v-if="isActive">
        <div class="loading-popup-terms popup-terms">
            <a href="javascript:void(0)" class="closebtn" @click="closePopupTerms()">&times;</a>
            <div class="h-100 m-5 align-items-center text-center m-0" style="overflow-y: auto; overflow-x: hidden; margin: 20;">
                <div class="row">
                    <div class="col align-items-center d-flex" style="justify-content: center;">
                        <div class="text-left d-inline-block">
                            <h2 class="popup-title">{{$t("Terms")}}</h2>
                        </div>
                    </div>
                </div>

                <div class="text-center mt-4">
                    <span class="message" v-html="message"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LoadingPopup',
        props: {
            active: Boolean,
            title: String,
            message: String,
            type: String,
            confirmationButton: String
        },
        methods: {
            closePopupTerms(){
                this.$emit('closePopupTerms');
            }
        },
        computed: {
            isActive(){
                return this.active;
            }
        }
    }
</script>

<style>

/* Track */
::-webkit-scrollbar-track {
  background: #fff;
}
    .loading-wrapper-terms{
        background: rgba(0, 0, 0, 0.70);
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        z-index: 99999999;
    }

    .loading-popup-terms{
        width: 90%;
        min-width: 320px;
        max-width: 900px;
        height: 500px;
        background: #ffffff;
        border-radius: 20px;
        position: absolute;
        
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding-bottom: 50px;
        color: #264076;
        z-index: 99999999;
    }

    .loader{
        width: 50px;
        height: 50px;
    }

    .popup-terms .close-icon {
        color: var(--primary) !important;
        margin-bottom: 0px;
        font-size: 20px !important;
        display: flex;
    }

    .popup-terms .popup-title {
        color: var(--primary) !important;
        margin-bottom: 10px;
        font-size: 20px !important;
        display: flex;
    }

    .popup-terms  .icon {
        width: 50px;
        margin: 10px 10px;
    }

    .popup-terms  .message {
        text-align: left;
        color: #444;
        font-weight: lighter;
        font-size: 18px;
    }

    .popup-terms .btn-confirm {
        position: absolute;
        bottom: 0;
        left: 0;
        border-radius: 0px 0px 20px 20px;
        padding: 15px;
        width: 100%;
        border: none;
        background: #89d24c;
        color: #fff;
        font-weight: 400;
        font-size: 22px;
    }

    .popup-terms .btn-confirm:not(:disabled):not(.disabled):active, .btn-confirm:not(:disabled):not(.disabled).active, .show > .btn-confirm.dropdown-toggle {
        color: #fff;
        background-color: #72b53a;
        border-color: #72b53a;
    }

    .popup-terms .closebtn {
    color: var(--special-font);
    right: 20px;
    top: 5px;
    position: absolute;
    font-size: 40px;
  }

    .popup-terms .btn-confirm:focus, .btn-confirm.focus {
        box-shadow: none;
    }

</style>